import React from "react"
import Header from "./header"
import Footer from "./footer"
import "../styles/main.scss"
import layoutStyles from "./layout.module.scss"

const Layout = (props) => {

    return(
        
        <div className = { layoutStyles.container }>
            <Header />
            <div className="spaceContainer"></div>
                { props.children } 
            <Footer />
        </div>
    
    )
}

export default Layout